import RefreshIcon from "@mui/icons-material/Refresh";
import { Button } from "@mui/material";
import { FC } from "react";
import { useHistory } from "react-router-dom";

type MunicipalityChangeCityButtonProps = {
  id?: string;
  dataTestId?: string;
  className?: string;
};

export const MunicipalityChangeCityButton: FC<MunicipalityChangeCityButtonProps> =
  ({
    id = "municipality-home-change-city",
    dataTestId = "municipality-home-change-city",
    className = "xvia-municipality-change-city-button",
  }) => {
    const history = useHistory();

    return (
      <Button
        id={id}
        data-testid={dataTestId}
        className={className}
        startIcon={<RefreshIcon />}
        onClick={() => history.push("/list/municipios")}
      >
        Mudar município
      </Button>
    );
  };
